import { Navigate } from 'react-router-dom';
import { Targets } from './Targets';

export const targetRoutes = [
  { index: true, element: <Targets /> },
  { path: '*', element: <Navigate to={'.'} /> },
];
